// extracted by mini-css-extract-plugin
export default {"select":"CalendarTimeRangeSwitch_select__PO0VJ"};